import { NgModule } from '@angular/core';
import { InformacionPagoPensionHomeComponent } from './pages/informacion-pago-pension-home/informacion-pago-pension-home.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { InformacionPagoPensionRoutingModule } from './informacion-pago-pension-routing.module';
import { PagoPensionService } from "./core/services/pago-pension.service";
import { SharedModule } from '@shared/shared.module';
import { StorageService } from '@services/storage/storage.service';
import { ConfirmModalModule } from '@shared/components/confirm-modal/confirm-modal.module';
import { InsideViewportDirective } from './core/directives/inside-viewport.directive';

@NgModule({
  imports: [
    InformacionPagoPensionRoutingModule,
    CommonModule,
    IonicModule,
    SharedModule,
    ConfirmModalModule
  ],
  providers: [
    PagoPensionService,
    SharedModule,
    StorageService
  ],
  declarations: [
    InformacionPagoPensionHomeComponent,
    InsideViewportDirective    
  ],
})
export class InformacionPagoPensionModule {}